import { api } from './api';

export interface AdminStats {
  users: number;
  companies: number;
  workspaces: number;
  aiSpendCentsMtd: number;
  aiRunsMtd: number;
}

export interface AdminUser {
  id: string;
  email: string | null;
  name: string | null;
  picture_url: string | null;
  is_admin: boolean;
  is_active: boolean;
  email_verified: boolean;
  country_code: string | null;
  created_at: string;
  company_count: number;
  workspace_count: number;
  ai_spend_cents_mtd: number;
}

export interface AdminAiSpendBucket {
  ymd: string; agent: string; model: string; runs: number; cents: number;
}

export interface AdminActivityRow {
  when: string;
  actor_id: string | null;
  actor_email: string | null;
  action: string;
  target_kind: string | null;
  target_id: string | null;
  workspace_id: string | null;
}

export const adminApi = {
  async stats(): Promise<AdminStats> {
    return (await api.get<AdminStats>('/api/admin/stats')).data;
  },
  async users(query: { limit?: number; offset?: number; q?: string } = {}): Promise<{ rows: AdminUser[]; total: number }> {
    return (await api.get<{ rows: AdminUser[]; total: number }>('/api/admin/users', { params: query })).data;
  },
  async patchUser(id: string, flags: { isAdmin?: boolean; isActive?: boolean }): Promise<void> {
    await api.patch(`/api/admin/users/${id}`, flags);
  },
  async aiSpend(): Promise<AdminAiSpendBucket[]> {
    return (await api.get<AdminAiSpendBucket[]>('/api/admin/ai-spend')).data;
  },
  async activity(limit = 100): Promise<AdminActivityRow[]> {
    return (await api.get<AdminActivityRow[]>('/api/admin/activity', { params: { limit } })).data;
  },
};
